<template>
  <div
    :class="[
      'before:bg-surface-background',
      'before:fixed',
      `before:content-['']`,
      'before:top-0',
      'before:left-0',
      'before:w-[100vw]',
      'before:h-[100vh]',
      'before:z-[-10]',
    ]"
  >
    <slot />
  </div>
</template>
